import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/Filters.js
var Filters = class {
  constructor(el) {
    let searchTerm;
    if (window.location.href.includes("?q=") || window.location.href.includes("&q=")) {
      searchTerm = window.location.href.split("q=")[1].split("&")[0];
    } else {
      searchTerm = "";
    }
    let sortBy;
    if (window.location.href.includes("sort_by=")) {
      sortBy = window.location.href.split("sort_by=")[1].split("&")[0];
    } else {
      sortBy = "";
    }
    el.addEventListener("submit", (e) => {
      e.preventDefault();
      const filters = Array.from(el.querySelectorAll("input:checked")).map((el2) => el2.value + "&").join("");
      let url = `${location.pathname}?${filters}`;
      if (sortBy !== "") {
        url += `sort_by=${sortBy}`;
      }
      if (searchTerm !== "") {
        url += `&q=${searchTerm}`;
      }
      location.href = url;
    });
    el.querySelector("[data-clear-all]").addEventListener("click", () => {
      let url = `${location.pathname}`;
      if (searchTerm !== "") {
        url += `?q=${searchTerm}`;
      }
      if (sortBy !== "") {
        url += `?sort_by=${sortBy}`;
      }
      location.href = url;
    });
  }
};
var Filters_default = Filters;
export {
  Filters_default as default
};
